import { render, staticRenderFns } from "./disturite.vue?vue&type=template&id=5f5c0320&scoped=true"
import script from "./disturite.vue?vue&type=script&lang=js"
export * from "./disturite.vue?vue&type=script&lang=js"
import style0 from "./disturite.vue?vue&type=style&index=0&id=5f5c0320&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c0320",
  null
  
)

export default component.exports